<template>
  <!-- 大学详情页院校标签 -->
  <div class="pc-regionDetail-cities-tags">
    <div class="important-cities">
      <div class="title">
        <p>重要城市:</p>
      </div>
      <ul>
        <li
          :class="managerState ? 'managerClass' : ''"
          v-for="(item, index) in importantCities"
          :key="index"
          @click="goCity(item.id)"
        >
          <span>{{ item.name }}</span>
          <i
            v-show="managerState"
            @click="removeTypeTag(item.id,'1')"
            class="el-icon-close"
          ></i>
        </li>
        <li @click="addNewCity('1')">添加城市</li>
      </ul>
    </div>

    <div class="cities">
      <div class="title">
        <p>包含城市:</p>
        <p>
          总数
          <span>{{ total }}</span>
        </p>
      </div>
      <ul>
        <li
          :class="managerState ? 'managerClass' : ''"
          v-for="(item, index) in cities"
          :key="index"
          @click="goCity(item.id)"
        >
          <span>{{ item.name }}</span>
          <i
            v-show="managerState"
            @click="removeTypeTag(item.id,'0')"
            class="el-icon-close"
          ></i>
        </li>

        <li @click="addNewCity('0')">添加城市</li>
      </ul>
    </div>

    <!-- 添加标签的模态框 -->
    <el-dialog :visible.sync="dialogVisible">

<!-- 
      <el-select v-model="selectedCity" value-key="id" placeholder="选择城市">

        <el-option
          v-for="item in allCities"
          :key="item.id"
          :label="item.name"
          :value="item"
        ></el-option>


      </el-select> -->

       <el-autocomplete
          clearable
          :popper-append-to-body="false"
          v-model="selectedCityName"
          :fetch-suggestions="querySearchAsync"
          @select="handleSelect"
          placeholder="选择城市"
        >
        </el-autocomplete>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button
          :disabled="selectedCity == null"
          type="primary"
          @click="checkTag"
          >新 增</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 页面模板;
import {
  getCities,
  addCitytoCityGroup,
  deleteCitytoCityGroup,
} from "./regionDetail.gql";
export default {
  props: { name: String, managerState: Boolean, oprateType: String },
  data() {
    return {
      importantCities: [],
      cities: [],
      selectedCity: null,
      selectedCityName:null,
      cityArgs: {
        keywords: "",
        isImportant: "",
      },
      total: 0,
      allCities: [],

      // 添加标签模态框
      dialogVisible: false,
      // 判断
      addAreaType: false,
      // 删除弹框的显示隐藏
      addCityArgs: {
        cityId: "",
        cityGroupId: "",
        isImportant: "",
      },
    };
  },
  created() {
    this.getCities();
  },
  watch: {
    name(val) {
      this.cityArgs.keywords = val;
      this.getCities(this.cityArgs);
    },
  },
  methods: {

    handleSelect(item) {
      console.log(item);
      this.selectedCity = item;
      // this.selectItem = item;
    },
    querySearchAsync(queryString, callback) {
      this.$global
        .GraphqlQuery(this, getCities, {
          status: -1,
          take: 0,
          order: "+name",
          name: this.selectedCityName,
        })
        .then((res) => {
          for (let i of res.data) {
            i.value = i.name; //将想要展示的数据作为value
          }
          this.scholarData = res.data;
          callback(this.scholarData);
        });
    },

    goCity(id) {
      this.$router.resolve({
        path: "/admin/cityDetail",
        name: "cityDetail",
        query: {
          id: id,
        },
      });
      //  window.open(routeUrl.href, '_blank');
    },

    // 标签下拉框显示
    getCities(cityArgs) {
      this.$global.GraphqlQuery(this, getCities, cityArgs).then((res) => {
        if (cityArgs) {
          this.total = res.total;
          this.cities = res.data;
          this.importantCities = [];
          this.cities.forEach((item) => {
            if (item.isImportant == "1") {
              this.importantCities.push(item);
            }
          });
        } else {
          this.allCities = res.data;
        }
      });
    },

    addNewCity(isImportant) {
      this.dialogVisible = true;
      this.addCityArgs.isImportant = isImportant;
    },

    // 详情页新增标签
    checkTag() {
      console.log(this.selectedCity)
      if (this.oprateType == "add") {
        this.addCityArgs.cityId = this.selectedCity.id;
        this.dialogVisible = false;

        if (this.addCityArgs.isImportant == "0") {
          this.selectedCity.isImportant="0"
          this.cities.push(this.selectedCity);
        }
        if (this.addCityArgs.isImportant == "1") {
          this.selectedCity.isImportant="1"
          this.cities.push(this.selectedCity);
          this.importantCities.push(this.selectedCity);
        }
        this.cities = Array.from(new Set(this.cities));
        this.importantCities = Array.from(new Set(this.importantCities));
        console.log(this.cities);
      } else {
        this.addCityArgs.cityId = this.selectedCity.id;
        this.addCityArgs.cityGroupId = this.$route.query.id;
        this.$global
          .GraphqlMutation(this, addCitytoCityGroup, this.addCityArgs)
          .then((res) => {
            this.dialogVisible = false;
            this.$global.success(this, "操作成功");
            this.getCities(this.cityArgs);
          });
      }

      // this.dialogFormVisible = false;
    },
    // 移除该标签
    removeTypeTag(id,isImportant) {
      if (this.oprateType == "add") {
        if(isImportant=='0'){
          this.cities.forEach((item,index)=>{
            if(item.id==id){
              this.cities.splice(index,1)
            }
          })
        }
        if(isImportant=='1'){
          this.importantCities.forEach((item,index)=>{
            if(item.id==id){
              this.importantCities.splice(index,1)
            }
          })
          this.cities.forEach((item,index)=>{
            if(item.id==id){
              this.cities.splice(index,1)
            }
          })
        }
      } else {
        this.addCityArgs.cityId = id;
        this.addCityArgs.cityGroupId = this.$route.query.id;
        this.$global
          .GraphqlMutation(this, deleteCitytoCityGroup, this.addCityArgs)
          .then((res) => {
            this.dialogVisible = false;
            this.$global.success(this, "操作成功");
            this.getCities(this.cityArgs);
          });
      }
    },
    getAddedCities() {
      return this.cities;
    },
  },
};
</script>
<style lang="scss" scoped>
// 大学院校标签
.pc-regionDetail-cities-tags {
  margin-top: 10px;
  .important-cities,
  .cities {
    display: flex;
    .title {
      flex-shrink: 0;
      margin-right: 20px;
      width: 80px;
      text-align: right;
      line-height: 40px;
      font-size: 16px;
      p {
        // width:80px;
        font-size: 16px;
        text-align: right;
        span {
          color: $lightenYellow;
          font-size: 24px;
        }
      }
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        min-width: 70px;
        height: 44px;
        text-align: center;
        padding: 11px 21px;
        border: 1px solid $universityBorder;
        background: $universityBackground;
        margin-right: 20px;
        margin-bottom: 20px;
        color: $timeBtn;
        font-size: 14px;
        font-family: $english;
        border-radius: 4px;
        .el-icon-close {
          margin-left: 5px;
        }
      }
      li:last-child {
        border: 1px dashed $timeBtn;
        background: none;
        cursor: pointer;
      }
      .managerClass {
        transition: transform 0.3s;
      }
      .managerClass:hover {
        transform: translateY(-10px);
        cursor: pointer;
      }
    }
  }
}
// elForm 弹出框的样式
/deep/ .el-dialog {
  width: 31%;
  box-shadow: $boxshadow;
  border-radius: 4px;
  .el-dialog__body {
    text-align: center;
  }
  .el-dialog__footer {
    padding: 10px 25% 20px;
    .dialog-footer {
      height: 28px;
      display: flex;
      justify-content: space-around;
      .el-button--default:hover {
        background: $base-color;
      }
      .el-button--default {
        border-radius: 100px;
        border: 1px solid $schoolTagBorder;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $schoolTagColor;
        }
      }
      .el-button--primary {
        border-radius: 100px;
        background: $pageViewSmall;
        border: 1px solid $pageViewSmall;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $base-color;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/map/regionDetail/addCity.vue